import { SearchRefDataInterface } from '../response/interfaces/searchRefData.interface';
import { SearchRefDataModel } from '../response/models/searchRefData.model';
import { AssetAdvancedSearchServiceEnum } from '../../../services/api-names';
import { Injectable, Inject } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import {
  TECH_LIB_PORTAL_CONFIG,
  TechLibPortalConfig,
} from '../../../tech-lib-portal.interceptor';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AdvancedSearchInterface } from '../response/interfaces/advancedSearch.interface';
import { AdvancedSearchModel } from '../response/models/advancedSearch.model';
import { AdvancedSearchRequestInterface } from '../request/interfaces/advancedSearchRequest.interface';
import { SessionService } from '../../../services/session.service';

/**
 * Servicio para realizar búsquedas
 */
@Injectable({
  providedIn: 'root',
})
export class AssetAdvancedSearchService {
  constructor(
    @Inject(TECH_LIB_PORTAL_CONFIG) private config: TechLibPortalConfig,
    private httpClient: HttpClient,
    private session: SessionService
  ) {}

  private updateSession() {
    this.config.sessionToken = this.session.sessionToken;
    this.config.domain = this.session.domain;
    this.config.clientCode = this.session.clientCode;
    this.config.language = this.session.language;
  }

  assetSearchRefData(): Observable<SearchRefDataInterface> {
    const url =
      this.config.baseApi +
      AssetAdvancedSearchServiceEnum.apirest_asset_search_refdata;
    this.updateSession();
    return new Observable((observer: Observer<SearchRefDataModel>) => {
      this.httpClient
        .get(url)
        .pipe(
          map((resp: any) => {
            return new SearchRefDataModel(resp);
          })
        )
        .subscribe(
          (resp: any) => {
            observer.next(resp);
            observer.complete();
          },
          (err) => observer.error(err)
        );
    });
  }

  assetAdvancedSearch(
    advancedSearchRequest: AdvancedSearchRequestInterface
  ): Observable<AdvancedSearchInterface> {
    const url =
      this.config.baseApi +
      AssetAdvancedSearchServiceEnum.apirest_asset_advanced_search;
    const body = advancedSearchRequest;
    this.updateSession();
    return new Observable((observer: Observer<AdvancedSearchModel>) => {
      this.httpClient
        .post(url, body)
        .pipe(
          map((resp: any) => {
            return new AdvancedSearchModel(resp);
          })
        )
        .subscribe(
          (resp: any) => {
            observer.next(resp);
            observer.complete();
          },
          (err) => observer.error(err)
        );
    });
  }
}
